import request from '../utils/request';

// 查询供应商装备列表
export function getAddr() {
  return request({
    url: '/getAddr?apipost_id=2ceb817b9b033',
    method: 'get',
  });
}
